import { ApolloLink } from "@apollo/client";

const TIMESTAMP = Date.now();
const TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const graphQlVariablesLink = new ApolloLink((operation, forward) => {
  const defaultData = {
    timestamp: TIMESTAMP,
    timezone: TIMEZONE,
  };

  operation.variables = {
    ...operation.variables, // Preserve existing variables
    ...defaultData,
  };

  return forward(operation);
});
